// Objective builders registry (placeholder for future objectives).
// Interface: (model, params) => ObjectiveSpec | null
import { buildMaximizeAllocationObjective } from './maximizeAllocation';
import { buildMediaMaximizeAllocationObjective } from './mediaMaximizeAllocation';

export const ObjectiveBuilders = {
  maximizeAllocation: buildMaximizeAllocationObjective,
  mediaMaximizeAllocation: buildMediaMaximizeAllocationObjective,
  // Future:
  // maximizeCoverage: buildMaximizeCoverage,
  // balanceWorkload: buildBalanceWorkload,
};
